<script lang="ts">
	import BackgroundJobIndicator from '$lib/components/BackgroundJobIndicator.svelte';
	import Layout from '$lib/components/layout/Layout.svelte';
	import MarketingLayout from '$lib/components/layout/MarketingLayout.svelte';
	import ModernLayout from '$lib/components/layout/ModernLayout.svelte';
	import AnnouncementContainer from '$lib/components/ui/AnnouncementContainer.svelte';
	import NotificationContainer from '$lib/components/ui/NotificationContainer.svelte';
	import { enhancedCartStore } from '$lib/stores/enhancedCart.svelte';
	import type { Market } from '$lib/types/market';
	import type { User } from '$lib/types/user';
	import '../app.css';

	let { data, children } = $props<{
		title: string;
		loggedIn: boolean;
		market: Market;
		user: User;
		isModernPage: boolean;
		flash: { notice?: string; warning?: string };
		isStripePage?: boolean;
		children: () => import('svelte').Snippet;
	}>();

	let isShowcasePage = $derived(data.isShowcasePage);
	let isModernPage = $derived(!isShowcasePage && data.isModernPage);
	let isMarketingPage = $derived(!data.market && !data.isModernPage && !isShowcasePage);

	// Force modern layout for error pages
	let forceModernForError = $state(false);

	$effect(() => {
		// Only run in browser
		if (typeof document === 'undefined') return;

		// Check if we're on an error page by looking for error elements
		const errorElement = document.querySelector('[data-error]');
		forceModernForError = !!errorElement;
	});

	// Override isModernPage if we're on an error page
	let finalIsModernPage = $derived(forceModernForError || isModernPage);

	// Initialize the cart store with user and market context
	$effect(() => {
		const userId = data.user?.id || null;
		const marketId = data.market?.id || null;
		enhancedCartStore.initialize(userId, marketId);
	});
</script>

{#if isShowcasePage}
	<!-- Showcase pages render directly without any wrapper layout -->
	{@render children()}
{:else if finalIsModernPage}
	<ModernLayout title={data.title} market={data.market}>
		{@render children()}
	</ModernLayout>
{:else if isMarketingPage}
	<MarketingLayout title={data.title} user={data.user}>
		{@render children()}
	</MarketingLayout>
{:else}
	<Layout
		title={data.title}
		loggedIn={data.loggedIn}
		market={data.market}
		user={data.user}
		flash={data.flash}
	>
		{@render children()}
	</Layout>
{/if}

<!-- Global notification container -->
<NotificationContainer />

<!-- Global announcement container -->
<AnnouncementContainer user={data.user} />

<!-- Background job indicator -->
<BackgroundJobIndicator />
